import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {SignInComponent} from './sign-in/sign-in.component';
import {ForgotPasswordComponent} from './forgot-password/forgot-password.component';
import {ResetPasswordComponent} from './reset-password/reset-password.component';
import {SignUpComponent} from './sign.up/sign.up.component';
import {AccountVerificationComponent} from './account-verification/account-verification.component';
import {AboutYouComponent} from './about-you/about-you.component';
import {UserAccountComponent} from './user-account/user-account.component';
import {ProfileComponent} from './profile/profile.component';
import {ReportDetailsComponent} from './reports/report-details/report-details.component';
import {LoginGuard} from '../../../_helpers/login.guard';

const routes: Routes = [
  {
    path: 'sign-in/:project',
    component: SignInComponent,
    canActivate: [LoginGuard]
  },
  {
    path: 'sign-up',
    component: SignUpComponent,
    canActivate: [LoginGuard]
  },
  {
    path: 'about-you',
    component: AboutYouComponent
  },
  {
    path: 'final-bit',
    component: UserAccountComponent,
    canActivate: [LoginGuard]
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
    canActivate: [LoginGuard]
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent,
    canActivate: [LoginGuard]
  },
  /*{
    path: 'terms-condition',
    component: TermsConditionAuthComponent
  },*/
  {
    path: 'account-verification',
    component: AccountVerificationComponent,
    canActivate: [LoginGuard]
  },
  {
    path: 'profile/:page',
    component: ProfileComponent
  },
  {
    path: 'report',
    component: ReportDetailsComponent
  },
  {
    path: 'admin',
    component: SignInComponent,
    canActivate: [LoginGuard]
  }

];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule]
})
export class AuthenticationRoutingModule {
}
